import React, { useState } from 'react';
import { Loader2, Tag, X } from 'lucide-react';
import type { DiscountCodeState } from './useDiscountCode';
import type { DiscountCodeWords } from './discountCodeWords';
import './discountCodeField.css';

// The checkout's discount code: a link that opens the field, the field with Apply, the applied code as a chip with
// Remove, and the reason when a code does not apply. Enter applies the code without sending the order.
export const DiscountCodeField: React.FC<{ discount: DiscountCodeState; words: DiscountCodeWords }> = ({ discount, words }) => {
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState('');
  const message = discount.refusal ? (discount.refusal === 'FAILED' ? words.failed : words.refusals[discount.refusal]) : null;

  if (discount.applied) {
    return (
      <div className="form-group discount-applied">
        <span className="discount-chip">
          <Tag size={14} aria-hidden />{discount.applied.code}
        </span>
        <button type="button" className="discount-remove" onClick={() => { discount.remove(); setTyped(''); }} aria-label={`${words.remove} ${discount.applied.code}`}>
          <X size={14} aria-hidden />{words.remove}
        </button>
        {discount.beaten && <span className="discount-beaten" dir="auto">{words.beaten}</span>}
      </div>
    );
  }
  if (!open) {
    return (
      <button type="button" className="discount-open" onClick={() => setOpen(true)}>
        {words.toggle}
      </button>
    );
  }
  return (
    <div className="form-group">
      <label className="form-label" htmlFor="xshop-discount-code">{words.label}</label>
      <div className="discount-entry">
        <input id="xshop-discount-code" className={`form-input${message ? ' error' : ''}`} value={typed} autoFocus autoComplete="off" autoCapitalize="characters"
          aria-invalid={message ? true : undefined} aria-describedby={message ? 'xshop-discount-code-error' : undefined} dir="ltr"
          onChange={(e) => setTyped(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); discount.apply(typed); } }} />
        <button type="button" className="discount-apply" onClick={() => discount.apply(typed)} disabled={discount.busy || !typed.trim()}>
          {discount.busy && <Loader2 className="animate-spin" size={16} aria-hidden />}{words.apply}
        </button>
      </div>
      {message && <span className="field-error" id="xshop-discount-code-error" role="alert" dir="auto">{message}</span>}
    </div>
  );
};
